export default "__VITE_ASSET__OP6oEnl0__"